@if (sponsors().length > 0) {
  <div class="sponsors-section">
    <p class="sponsors-title">{{ 'Our Sponsors' | translate }}</p>
    <p-carousel
      [value]="sponsors()"
      [numVisible]="4"
      [numScroll]="1"
      [circular]="true"
      [autoplayInterval]="3000"
      [responsiveOptions]="responsiveOptions"
      [showIndicators]="false"
      [showNavigators]="false"
    >
      <ng-template #item let-sponsor>
        <div
          class="sponsor-item"
          [class.sponsor-item--discount]="hasDiscount(sponsor)"
          (click)="openPreview(sponsor)"
        >
          <img
            [src]="sponsor.logo_path"
            [alt]="sponsor.name"
            class="sponsor-logo"
            loading="lazy"
          />
          @if (hasDiscount(sponsor)) {
            <span class="discount-badge">%</span>
          }
        </div>
      </ng-template>
    </p-carousel>
  </div>
}

@if (previewSponsor(); as sponsor) {
  <div class="preview-overlay" (click)="closePreview()">
    <div class="preview-card" (click)="$event.stopPropagation()">
      <button class="preview-close" (click)="closePreview()">
        <span class="material-icons">close</span>
      </button>
      <img
        [src]="sponsor.logo_path"
        [alt]="sponsor.name"
        class="preview-img"
      />
      @if (sponsor.name) {
        <p class="preview-name">{{ sponsor.name }}</p>
      }
      @if (hasDiscount(sponsor)) {
        <div class="preview-discount">
          @if (sponsor.discount_value) {
            <span class="preview-discount__value">{{ sponsor.discount_value }}</span>
          }
          @if (sponsor.discount_description) {
            <span class="preview-discount__desc">{{ sponsor.discount_description }}</span>
          }
        </div>
      }
    </div>
  </div>
}
